import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { IGender } from '../../../../interfaces/common-interfaces';
import { AudioService } from '../../../../services/audio/audio.service';
import { MetrikaService } from '../../../../services/metrika.service';

@Component({
  selector: 'app-gender-select',
  templateUrl: './gender-select.component.html',
  styleUrl: './gender-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenderSelectComponent {
  @Output()
  close: EventEmitter<IGender> = new EventEmitter();


  selectedGender: undefined | IGender;

  constructor(
    private audio: AudioService,
    private cdr: ChangeDetectorRef,
    private metrika: MetrikaService,
  ) {}


  playClick() {
    this.audio.playClickCharacter();
  }
  playHover() {
    this.audio.playSelectCharacter();
  }
  select() {
    this.close.emit(this.selectedGender!);
  }

  choose(val: IGender) {
    this.selectedGender = val;
    this.metrika.reachGoal('gender_select', {gender: val});
    this.cdr.detectChanges();
  }
}
